import React from 'react';
import './index.css'

import { connect } from 'react-redux';

import { Link } from 'react-router-dom';
import Navbar from '../../../../../_components/common/Navbar';
import SideNavBar from '../../../../../_components/common/SideNavBar'
import { orgAdminAreaData, AnalyzeData } from '../../../OrgAdminArea/SidebarData'
import {
    Card, CardImg, CardText, CardBody,
    CardTitle,
} from 'reactstrap';
import AnalysisNavBar from '../../../../../_components/common/AnalysisNavBar'
import attrictionPredictor from '../../../../../images/attrictionPredictor.png';
import collaboration from '../../../../../images/collaboration.png'
import competency from '../../../../../images/competency.png'
import focusarea from '../../../../../images/focusarea.png'
import hiringProbability from '../../../../../images/hiringProbability.png'
import landd from '../../../../../images/landd.png';
import reviewquestions from '../../../../../images/reviewquestions.png'
import rolefitment from '../../../../../images/rolefitment.png'
import swot from '../../../../../images/swot.png'
import teamfitment from '../../../../../images/teamfitment.png'
import virtualteam from '../../../../../images/virtualteam.png'
import './index.css'
import { orgAdminAction, saveModulePermissionsAction, saveTeamDetailsAction, analyseActions } from '../../../../../_actions';
import { AnalyzeAction } from '../../../../../_actions/Analyze/analyze.action'

import { competencyListAction } from '../../../../../_actions/Analyze/competencyList.action'
import { lndAction} from '../../../../../_actions/Analyze/lnd.action'
import { attritionPredictorAction } from '../../../../../_actions/Analyze/attritionPredictor.action'

import {userListAction} from '../../../../../_actions/Analyze/userList.action'
import { getPaAnanlyzeTeamListAction } from '../../../../../_actions/Analyze/getPaAnanlyzeTeamList.action'

import OverLayLoader from '../../overLayLoader';

class DashBoard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            teamName: '',
            teamId: '',
            filterData: null,
            getPaUserPermissionListResponse: '',
            navData: [],
            data: [
                {
                    subNavName: 'SWOT',
                    link: `/organisation/${props.match.params.id}/user/swot/0`,
                    image: swot,
                    text: "Strengths, Weaknesses, Opportunities, & Threats",
                    cata: "swot",
                },
                {
                    subNavName: 'Focus Areas',
                    link: `/organisation/${props.match.params.id}/user/focus-area`,
                    image: focusarea,
                    text: "Potential pitfalls and preventive actions",
                    cata: "focus-area",
                },
                {
                    subNavName: 'Review Questions',
                    link: `/organisation/${props.match.params.id}/user/review-questions`,
                    image: reviewquestions,
                    text: "Questions for effective Project/Operations reviews",
                    cata: "review-questions",
                },
                {
                    subNavName: 'Collaboration',
                    link: `/organisation/${props.match.params.id}/user/collaboration`,
                    image: collaboration,
                    text: "Inter-team comparison for greater synergy",
                    cata: "collaboration",
                },
                {
                    subNavName: 'Role Fitment',
                    link: `/organisation/${props.match.params.id}/user/role-fitment`,
                    image: rolefitment,
                    text: "Fitment of an individual for a particular role",
                    cata: "role-fitment",
                },
                {
                    subNavName: 'Team  Fitment',
                    link: `/organisation/${props.match.params.id}/user/compability`,
                    image: teamfitment,
                    text: "Fitment of an individual with a team",
                    cata: "compability",
                },
                {
                    subNavName: 'Competency',
                    link: `/organisation/${props.match.params.id}/user/competency-indicator`,
                    image: competency,
                    text: "Proficiency indicator and improvement areas",
                    cata: "competency",
                },
                {
                    subNavName: 'L&D',
                    link: `/organisation/${props.match.params.id}/user/learning-and-development`,
                    image: landd,
                    text: "Individual learning needs & peer-coach recommendations",
                    cata: "l&d",
                },
                {
                    subNavName: 'ATTRITION PREDICTOR',
                    link: `/organisation/${props.match.params.id}/user/attrition-predictor`,
                    image: attrictionPredictor,
                    text: "Preventing probable attrition with retention tips",
                    cata: "attrition-predictor",
                },
                // {
                //     subNavName: 'Hiring Probability',
                //     link: `/organisation/${props.match.params.id}/user/hiring-probability`,
                //     image: hiringProbability,
                //     text: "What-If analysis for a probable hiring scenario",
                //     cata: "hiring-probability",
                // },
                {
                    subNavName: 'Virtual Teams',
                    link: `/organisation/${props.match.params.id}/my-teams`,
                    image: virtualteam,
                    text: "What-If analysis for team formation",
                    cata: "virtual-teams",
                }
            ]
        }
    }

    componentDidUpdate(prevProp) {
        if(prevProp.saveAssesorGroupListResponse !== this.props.saveAssesorGroupListResponse) {
            if(this.props.saveAssesorGroupListResponse !== '') {
                this.setState({filterData: this.props.saveAssesorGroupListResponse})
            }
        }
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(this.props.headPerLoadingResonse.data.is_pa_user == true) {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(this.props.headPerLoadingResonse.data.is_org_admin == true) {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(this.props.headPerLoadingResonse.data. is_super_admin == true) {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {

        if(this.props.location.state === undefined) {
            // // this.props.dispatch(getPaAnanlyzeTeamListAction.getPaAnanlyzeTeamListDataAction(this.props.match.params.id))
            // this.props.dispatch(getPaAnanlyzeTeamListAction.getPaAnanlyzeTeamListDataAction(this.props.match.params.id,(callback_Data) => {
            //     var reformatdata = []
            //     var tableData = callback_Data.data
            //     for (var key in tableData) {
            //         if (tableData.hasOwnProperty(key)) {
            //             reformatdata = reformatdata.concat(tableData[key])
            //         }
            //     }
    
            //     var sortedArray =  reformatdata.sort(function(a, b) { 
            //         return a.team_type - b.team_type  ||  a.team_name.localeCompare(b.team_name);
            //       });
    
                  
    
            //     // var reformatdata = callback_Data.data.organisation_teams
            //     const fd = {
            //         'teamName': sortedArray.length > 0 ? sortedArray[0].team_name : '',
            //         'teamId': sortedArray.length > 0 ? sortedArray[0].id : '',
            //         'orgId': this.props.match.params.id
            //     }
            //     localStorage.setItem('teamId', sortedArray.length > 0 ? sortedArray[0].id : '')
            //     localStorage.setItem('teamName', sortedArray.length > 0 ? sortedArray[0].team_name : '')
    
            //     this.props.dispatch(saveTeamDetailsAction.saveTeamDetailHandler(fd))
            //     let assessorIds = [];
            //     let assessmentIds = [];
            //     if (sortedArray.length !== 0 && sortedArray !== '') {
    
            //         this.props.dispatch({
            //             type: "TEAMS_AVAILABLE",
            //             payload: ""
            //         })
    
            //         const team = {
            //             "team_id": sortedArray[0].id
            //         }
            //         //assessor_groups_for_team & team_members
            //         this.props.dispatch(analyseActions.getAssessorGroupsHandler(team,(callback_Data) => {
            //             const assessor_groups_for_team_temp = []
            //             callback_Data.data.assessor_groups_for_team.map(
            //                 (data, i) => {
            //                     assessor_groups_for_team_temp.push({
            //                         ...data,
            //                         'value': data.value
            //                     })
            //                 }
            //             )
            //             const fd1 = {
            //                 'assessor_groups_for_team': assessor_groups_for_team_temp,
            //                 'team_members': callback_Data.data.team_members
            //             }
            //             //team members and respondents
            //             this.props.dispatch(analyseActions.saveAssessorGroups(fd1))
            //             if(fd1.team_members.length > 1) {
            //                 for (let i = 0; i < fd1.assessor_groups_for_team.length; i++) {
            //                     if (fd1.assessor_groups_for_team[i].value === true) {
            //                         assessorIds.push(fd1.assessor_groups_for_team[i].id)
            //                     }
            //                 }
            //                 for (let i = 0; i < fd1.team_members.length; i++) {
            //                     assessmentIds.push(fd1.team_members[i].assessment.id)
            //                 }
            //             this.props.dispatch(AnalyzeAction.AnalyzeDataAction({"team_assessment_id": assessmentIds,"relation_group_ids": assessorIds}))
            //             this.props.dispatch(competencyListAction.competencyListDataAction({ "analytics_organisation": this.props.match.params.id }))
            //             this.props.dispatch(lndAction.lndDataAction({"team_assessment_id": assessmentIds,"relation_group_ids":assessorIds}))
            //             this.props.dispatch(attritionPredictorAction.attriPreDataAction({"team_assessment_id": assessmentIds,"relation_group_ids":assessorIds}))
            //             }
            //             const fd3 = {
            //                 "assessorIds": assessorIds,
            //                 "assessmentIds": assessmentIds,
            //             }
            //             //Assessment id's and respondent id's
            //             this.props.dispatch(analyseActions.saveAssessorIds(fd3))
            //         }))
            //     }
            //     else {
            //         const fd3 = {
            //             "assessorIds": [],
            //             "assessmentIds": [],
            //         }
            //         const fd1 = {
            //             'assessor_groups_for_team': [],
            //             'team_members': []
            //         }
            //         //team members and respondents
            //         this.props.dispatch(analyseActions.saveAssessorGroups(fd1))
            //         //Assessment id's and respondent id's
            //         this.props.dispatch(analyseActions.saveAssessorIds(fd3))
            //         this.props.dispatch(AnalyzeAction.AnalyzeDataAction({"team_assessment_id": [],"relation_group_ids": []}))
            //         this.props.dispatch(competencyListAction.competencyListDataAction({ "analytics_organisation": this.props.match.params.id }))
            //         this.props.dispatch(lndAction.lndDataAction({"team_assessment_id": [],"relation_group_ids":[]}))
            //         this.props.dispatch(attritionPredictorAction.attriPreDataAction({"team_assessment_id": [],"relation_group_ids":[]}))
            //         this.props.dispatch({
            //             type: "NO_TEAMS_AVAILABLE",
            //             payload: "No Teams Available!"
            //         })
            //     }
            // }))
        }


        //filter data
        if(this.props.saveAssesorGroupListResponse !== '') {
            this.setState({filterData: this.props.saveAssesorGroupListResponse})
        }

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})


    }

    doSomthing = (data) => {
        this.setState({filterData : data}, () => {
            this.props.dispatch(analyseActions.saveAssessorGroups(this.state.filterData))            
        })
    }

    // onChangeTeam = (teamDetails) => {
    //     const team = {
    //         "team_id": teamDetails.analytics_team_id
    //     }
    //     this.props.dispatch(analyseActions.getAssessorGroupsHandler(team, () => {
    //         this.props.dispatch(analyseActions.saveAssessorGroups(this.props.assessorGroupsResponse))
    //     }))
    // }

    render() {
        const { data, navData, orgId } = this.state;
        const { getOrgTeamsResponse, assessorGroupsResponse, saveAssesorGroupListResponse, saveModulePermissionsResponse } = this.props;
        
        return (
            <div>
                <Navbar navItems={navData} backgroundColor="black" />
                < div className="container-post-nav">
                
                    <SideNavBar
                        analyzeFilterData={this.state.filterData}
                        isAnalyse = {true}
                        organisationName={localStorage.getItem('orgName')}
                        orgId={this.props.match.params.id}
                        teamId={localStorage.getItem('teamId')}
                        teamName={localStorage.getItem('teamName')}
                        callBack={this.doSomthing.bind(this)}
                    // onChangeTeam={(data) => this.onChangeTeam(data)}
                    />
                    <OverLayLoader>
                        <div className="analyz-container">
                            <AnalysisNavBar
                                analyticsData={saveModulePermissionsResponse}
                                orgId={this.props.match.params.id}
                                analyticsType={'people'} />
                            <div className="dashboard-container-main" style={{padding: '2rem'}}>
                                {
                                this.props.singleValidatorResponse ?
                                <p className="text-center">
                                        Team Members should be more than 2
                                </p>:
                                    <React.Fragment>
                                    {
                                        // this.props.AnalyzeDataResonse == '' ?
                                        // !this.props.getAnalyzeError ?
                                        // <p className="text-center">
                                        //     <i className="fas fa-spinner fa-spin " ></i>
                                        //     &nbsp;loading
                                        // </p> 
                                        // :
                                        // <p className="text-center">No Team Members</p>
                                        
                                        // :
                                        <div className="d-flex flex-row flex-wrap justify-content-center dash-board-container">
                                            {
                                                data.map((val, key) => {
                                                    return (
                                                        this.props.saveModulePermissionsResponse ?
                                                        this.props.saveModulePermissionsResponse.length == 0 ?
                                                        <React.Fragment>
                                                            {
                                                                key == 0 && 
                                                                <p className="text-center font-weight-bold">No permissions provided for analyse</p> 
                                                            }
                                                        </React.Fragment>:
                                                        this.props.saveModulePermissionsResponse.map(
                                                            (data, i) => {
                                                                return (
                                                                    val.subNavName.toLowerCase() === data.module_list__module_name.toLowerCase() &&
                                                                    <div key={key} className="d-flex justify-content-center flex-wrap my-4 px-2" style={{width:'19%'}}>
                                                                        <Card tag={Link} to={val.link}>
                                                                        <CardImg top src={val.image} alt="Card image cap" />
                                                                            <CardBody>
                                                                                <CardTitle>{val.subNavName}</CardTitle>
                                                                                <p className="mb-0 text-dark" style={{fontSize: "0.9rem"}} >{val.text}</p>
                                                                            </CardBody>
                                                                        </Card>
                                                                    </div>
                                                                )
                                                            })
                                                            :
                                                            key == 0 &&
                                                            <p className="text-center my-3">
                                                                <i className="fas fa-spinner fa-spin " ></i>
                                                                &nbsp;loading
                                                            </p>  
                                                    )
                                                })
                                            }
                                        </div>
                                    }
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                    </OverLayLoader>
                </div>
            </div>


        );
    }
}

function mapStateToProps(state) {
    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
    const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
    const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';
    const saveModulePermissionsResponse = state.saveModulePermissionsReducer.data;

    const { getPaUserPermissionListLoading } = state.getPaUserPermissionListReducer;
    const getPaUserPermissionListError = state.getPaUserPermissionListReducer.error;
    const getPaUserPermissionListResponse = (!getPaUserPermissionListLoading && !getPaUserPermissionListError) ? state.getPaUserPermissionListReducer.data.data.message : '';

    const saveTeamDetailsResponse = state.saveTeamDetailsReducer.data;

    const { assessorGroupsLoading } = state.assessorGroupsReducer;
    const assessorGroupsError = state.assessorGroupsReducer.error;
    const assessorGroupsResponse = (!assessorGroupsLoading && !assessorGroupsError) ? state.assessorGroupsReducer.data.data : '';

    //Analyze
    const { getAnalyzeLoading } = state.getAnalyzeData
    const getAnalyzeError = state.getAnalyzeData.error
    const AnalyzeDataResonse = (!getAnalyzeLoading && !getAnalyzeError) ?  state.getAnalyzeData.data : '';

     //Header Permission
     const { headPerLoading } = state.headerPermissionReducer
     const headPerLoadingError = state.headerPermissionReducer.error
     const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

    const saveAssesorGroupListResponse = state.saveAssesorGroupListReducer.data;

    const saveAssesorIdsResponse = state.saveAssesorIdsReducer.data;
    const singleValidatorResponse = state.singleValidatorReducer.data;

    return {
        getModulePermissionsListResponse,
        saveModulePermissionsResponse,
        saveTeamDetailsResponse,
        getPaUserPermissionListResponse,
        assessorGroupsResponse,
        saveAssesorGroupListResponse,
        saveAssesorIdsResponse,
        getAnalyzeLoading,
        AnalyzeDataResonse,
        getAnalyzeError,
        singleValidatorResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
    }
}

export default connect(mapStateToProps)(DashBoard)



// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/DashBoard/index.js